export default __webpack_public_path__ + "static/media/rain_dayTime.af8be2a0.svg";